import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';

@Component({
  selector: 'app-message-notification-modal',
  templateUrl: './message-notification-modal.component.html',
  styleUrls: ['./message-notification-modal.component.css']
})
export class MessageNotificationModalComponent implements OnInit {
  @Input() messageDetail;
  @Output() close = new EventEmitter<any>();

  constructor(
    private router : Router,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
  }

  navigation(value){
    if (this.router.url.includes('support/chats')) {
      this.sharedDataService.setSupportChatRedirectEntity({id: value.driverAlert.sender._id});
    } else {
      this.router.navigate(['/support/chats/'], { state: { id: `${value.driverAlert.sender._id}` } });
    }
  }
}
